import React from "react";
import {store} from "../store";
import ListActions from "./actions";

export function createListManager(lists, settings = {}) {
    let initiated = settings.initiated || false;
    let lastRequesterId = null;
    const showSpinner = settings.show_spinner !== undefined ? settings.show_spinner : true;

    return {
        readLists(params = {}) {
            initiated = true;
            const action = ListActions.readLists(lists, params, showSpinner);
            lastRequesterId = action.requesterId;
            store.dispatch(action);
        },
        updateLists(params = {}) {
            initiated = true;
            const action = ListActions.readLists(lists, params, showSpinner, true);
            lastRequesterId = action.requesterId;
            store.dispatch(action);
        },
        onListReady() {
            if (!initiated)
                return false;

            const { List } = store.getState();
            const { completedIds } = List.queue;

            // console.log('qq onListReady', lastRequesterId, completedIds);
            const isListReady = completedIds.includes(lastRequesterId);
            if (isListReady)
                initiated = false;
            return isListReady;
        },
        notRequested() {
            if (!initiated)
                return true;

            const { List } = store.getState();
            const { completedIds } = List.queue;

            const isListReady = completedIds.includes(lastRequesterId);
            return !isListReady;
        },
        initiated,
        isListReady: () => {
            const { List } = store.getState();
            const { completedIds } = List.queue;

            return completedIds.includes(lastRequesterId);
        },
    };
}

export function useListManager(lists, settings) {
    const [listManager] = React.useState(createListManager(lists, settings));
    return listManager;
}

export function useList(lists, conditionToReadListFn) {
    const listManager = useListManager(lists, {show_spinner: false});
    const conditionToReadList = conditionToReadListFn(store.getState());

    // console.log('zz conditionToReadList', conditionToReadList)

    React.useEffect(() => {
        // console.log('zz React.useEffect', conditionToReadList, !listManager.initiated)
        if (conditionToReadList && !listManager.initiated) {
            // console.log('zz React.useEffect successful')
            listManager.readLists();
        }
    }, [conditionToReadList, listManager]);
}
